import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Avatars from './Avatars';
import MenuBtn from './MenuBtn';
// import RadioBtns from './RadioBtns';
const ProductViewHeader = {
   borderBottom: "1px solid #c7c7c7",
   minHeight: "52px"
}
const AccordianIcons = {
   width: "36px",
   height: "25px !important",
   marginLeft: '24px'
}

const MenuExteriorView = (props) => {


   // console.log('expanded',props.expanded)

   return (
      <div className="Accordians">
         <Accordion style={{ borderRadius: "0px" }} onChange={props.onChanged} expanded={props.expanded}>
            <AccordionSummary id="exteriorViewBtn" tabIndex="1"
               expandIcon={<ExpandMoreIcon />} style={ProductViewHeader} onKeyPress={props.onExterior} onClick={props.onExterior}>
               {/* <img  src="./img/dimensions.png" style={{width:"40px",height:"30px",paddingLeft: "2px",paddingTop: "2px"}}/> */}
               <Typography className="accordion-headers AccordiansHeader" style={{ fontWeight: "700",margin: "0px 0px" }}>{props.name}</Typography>
            </AccordionSummary>

           

            <AccordionDetails tabIndex="1" aria-label="Front" id="frontBtn" onKeyPress={props.onFrontMode} onClick={props.onFrontMode}>
               <MenuBtn style={AccordianIcons} submenu={window.finalLangues.front} source="./img/front.png" />
            </AccordionDetails>

            <AccordionDetails tabIndex="1" aria-label="Rear" id="rearBtn" onKeyPress={props.onRearMode} onClick={props.onRearMode}>
               <MenuBtn aria-hidden="true" style={AccordianIcons} submenu={window.finalLangues.rear} source="./img/rear.png" />
            </AccordionDetails>
           

         </Accordion>
      </div>
   );
}

export default MenuExteriorView;